import { useFormContext } from "react-hook-form";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";
import { TemplateMenu } from "@/components/Template/RxTemplates";

export default function AdviceSection() {
    const { register, formState } = useFormContext();

    return (
        <div className="space-y-2">
            <div className="relative">
                <Textarea
                    {...register("advice")}
                    placeholder="Add advice…"
                    rows={2}
                    className={cn(
                        "text-sm bg-card border border-field rounded-md",
                        "focus:border-ring focus:outline-none focus-visible:ring-1 focus-visible:ring-ring/20",
                        "placeholder:text-muted-foreground/60 placeholder:font-normal",
                        "resize-none min-h-0 pl-2.5 pr-9 py-2",
                        formState.errors?.advice && "border-destructive/60"
                    )}
                    maxLength={500}
                />
                <TemplateMenu type="advice" className="absolute right-1 top-1" />
            </div>
            {formState.errors?.advice && (
                <div className="text-xs text-destructive mt-1">
                    {formState.errors.advice.message as string}
                </div>
            )}
        </div>
    );
}